<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import { RouteNames } from '@/helpers/enums';
  import DataSeparator from '@/components/ui/DataSeparator.vue';
  import { NewReplyNotificationType } from '@/helpers/types';

  export default defineComponent({
    components: { DataSeparator },
    mixins: [Mixins],
    props: {
      data: {
        type: Object as () => NewReplyNotificationType,
        required: true,
      },
    },
    emits: {
      close: () => true,
    },
    methods: {
      onNotificationClicked(): void {
        this.$emit('close');
        this.$router.push({
          name: RouteNames.supportOrderProblemList,
          params: { facilityOrderId: this.data.id },
        });
      },
    },
  });
</script>

<template>
  <div @click="onNotificationClicked">
    <div class="d-flex flex-row align-items-center gap-8 mb-8">
      <h5 class="text-gray fw-semibold">{{ data.orderNumber }}</h5>
      <DataSeparator />
      <h5 class="text-gray fw-semibold">{{ data.customerName }}</h5>
    </div>
    <h4 class="fw-semibold">{{ data.body }}</h4>
    <hr class="dashed mt-16 mb-24" />
    <div class="d-flex flex-grow-1 justify-content-center">
      <p class="link fw-bold">{{ $t('actions.check_reply') }}</p>
    </div>
  </div>
</template>
